<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <div style="display: flex;">
        <h2>Grup Kampanyası Detay</h2>
        <v-btn
          color="#4d48f9"
          style="
            text-transform: none !important;
            color: white;
            margin-left: 30px;
          "
          id="menu-activator"
        >
          ALT KAMPANYA EKLE
        </v-btn>

        <v-menu
          activator="#menu-activator"
          bottom
          offset-x
          class="d-flex justify-space-around"
        >
          <v-list style="text-align: center;">
            <v-list-item @click="routeSubCampaignAdd()">
              <v-list-item-title style="font-weight: bold;">
                YENİ KAMPANYA EKLE
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item @click="openCampaignPopup">
              <v-list-item-title style="font-weight: bold;">
                MEVCUT KAMPANYALARDAN SEÇ
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-dialog v-model="showPopup" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Kampanyalar</span>
          </v-card-title>

          <v-card-text>
            <span>Alt kampanya olarak eklemek istediğin kampanyaları seç.</span>

            <v-data-table
              :search="campaignSelectListData.search"
              style="margin-top: 30px;"
              :headers="campaignHeaders"
              :items="campaignSelectList"
              :items-per-page="10"
              :options.sync="campaignSelectListData"
              :page.sync="campaignSelectListData.pageNumber"
              @update:page="getSelectedListPageNumber"
              @update:items-per-page="getItemPerPageForSelectedList"
              :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="campaignSelectListData.search"
                  label="Ara"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item.campaignGroupId="{ item }">
                <v-checkbox
                  color="#4d48f9"
                  :input-value="
                    item.campaignGroupId == campaignPageData.campaignGroupId
                  "
                  @change="toggleSelection(item.id)"
                ></v-checkbox>
              </template>
            </v-data-table>
            <div class="text-xs-center pt-2">
              <v-pagination
                v-model="campaignSelectListData.pageNumber"
                color="#4d48f9"
                :length="campaignSelectListPagination.pagesLength"
              ></v-pagination>
            </div>
            <v-card-actions>
              <v-row>
                <v-col cols="12" md="4">
                  <v-btn
                    depressed
                    color="#4d48f9"
                    style="
                      text-transform: none !important;
                      float: left;
                      color: white;
                    "
                    @click="addSubCampaigns()"
                  >
                    KAYDET
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Grup Kampanya Başlık</h4>
          <v-text-field
            v-model="campaignGroupTitle"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            align="bottom"
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="saveCampaignGroupTitle()"
          >
            KAYDET
          </v-btn>
        </v-col>
      </v-row>

      <v-container style="margin-left: 0; padding-left: 0;">
        <h2>Alt Kampanyalar</h2>

        <v-row>
          <v-col cols="12" md="4" sm="4">
            <h4>Kampanya Tipi</h4>
            <v-select
              v-model="campaignPageData.filterByCampaign"
              @change="filterByCampaignChanged"
              :items="campaignFilterItems"
              item-text="name"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <h4>Aktiflik/Pasiflik</h4>
            <v-select
              v-model="campaignPageData.filterByStatus"
              @change="filterByCampaignStatus"
              :items="statusFilterItems"
              item-text="name"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <h4>Segment</h4>
            <v-select
              v-model="campaignPageData.filterBySegment"
              @change="filterBySegmentStatus"
              :items="
                ['', ...allSegments].map((segment, i) => {
                  const segmentObj = allSegmentTypes.find(
                    (x) => x.value == segment,
                  )
                  return {
                    value: segment,
                    label: segmentObj ? segmentObj.label : 'Bilinmeyen Segment',
                  }
                })
              "
              item-text="label"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  :label="'Başlangıç tarihi'"
                  style="font-weight: bold;"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                :max="new Date().toISOString().substr(0, 10)"
                @change="filterByDateChange(date, endDate)"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              v-model="menu3"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  :label="'Bitiş tarihi'"
                  style="font-weight: bold;"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :min="nowDate"
                :disabled="datePickerDisable"
                :max="
                  new Date(
                    new Date().getFullYear() + 1,
                    new Date().getMonth(),
                    new Date().getDate(),
                  )
                    .toISOString()
                    .substr(0, 10)
                "
                @change="filterByDateChange(date, endDate)"
                @input="menu3 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-row cols="12" md="4">
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Son Kullanma Tarihi seçilen başlangıç ve bitiş tarihi arasında
              olan kampanyaları filtreler.
            </v-alert>
          </v-row>
          <v-col cols="12" md="4" sm="4" style="margin-top: -24px;">
            <h4>Paket Adı</h4>
            <v-select
              v-model="campaignPageData.filterBySubscriptionType"
              @change="filterBySubscriptionType"
              :items="
                allSubscriptionTypes.map((subscription) => {
                  return {
                    label: subscriptionLabels[subscription],
                    value: allSubscriptionTypes.indexOf(subscription),
                  }
                })
              "
              item-text="label"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="campaignPageData.search"
              append-icon="mdi-magnify"
              label="Ara"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card>
          <v-data-table
            style="margin-top: 30px;"
            :loading="loading"
            :headers="headers"
            :items="allCampaigns"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              disablePagination: true,
            }"
            :items-per-page="10"
            @update:page="getPageNumber"
            @update:items-per-page="getItemPerPage"
          >
            <template v-slot:item.shown="{ item }">
              <v-checkbox
                v-model="item.shown"
                color="#4d48f9"
                @change="campaignVisibilityChange(item)"
              ></v-checkbox>
            </template>
            <template v-slot:item.active="{ item }">
              <v-checkbox
                v-model="item.active"
                color="#4d48f9"
                @change="campaignStatusChange(item)"
              ></v-checkbox>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="routeCampaignEdit(item)">
                mdi-pencil
              </v-icon>
            </template>

            <template v-slot:item.endDate="{ item }">
              <div class="tooltip-container">
                <v-tooltip v-if="tooltipMessage(item).message" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :style="{ color: tooltipMessage(item).color }"
                      v-on="on"
                    >
                      {{ tooltipMessage(item).icon }}
                    </v-icon>
                  </template>
                  <span>{{ tooltipMessage(item).message }}</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="campaignPageData.pageNumber"
              color="#4d48f9"
              :length="pagination.pagesLength"
              @input="getPageNumber"
            ></v-pagination>
          </div>
        </v-card>
      </v-container>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GroupCampaignDetail',
  data: () => ({
    showPopup: false,
    popupOpen: false,
    showToolTip: false,
    alert: false,
    infoImage: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    campaignImg: undefined,
    campaignImgUrl: '',
    couponCodeCount: 1,
    codeUsedCount: 0,
    codeCreated: false,
    search: '',
    location: 'bottom',
    campaignGroupTitle: '',
    campaignFilterItems: [
      {
        name: 'Hepsi',
        value: '',
      },
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Ortaklığı',
        value: 'Partnership',
      },
      {
        name: 'Genel Kampanya',
        value: 'General',
      },
    ],
    statusFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Aktif',
        value: true,
      },
      {
        name: 'Pasif',
        value: false,
      },
    ],
    campaignPageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      filterByCampaign: '',
      filterByStatus: null,
      filterBySegment: '',
      filterBySubscriptionType: 2,
      startDate: null,
      endDate: null,
      campaignGroupId: null,
    },
    campaignSelectListData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    campaignSelectListPagination: {
      totalItems: 20,
      pagesLength: 0,
    },

    nowDate: '',
    datePickerDisable: true,
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    modal: false,
    menu2: false,
    menu3: false,
    headers: [
      { text: 'Kampanya ID', value: 'id', align: 'start', sortable: false },
      { text: 'Kampanya Başlık', value: 'title', sortable: false },
      { text: 'Kod Tipi', value: 'codeType', sortable: false },
      { text: 'Kullanılmış Kod/Toplam Kod', value: 'percent', sortable: false },

      { text: 'Kampanyalarda Göster', value: 'isShown', sortable: false },
      { text: 'Aktif/Pasif', value: 'isActive', sortable: false },
      { text: 'Öncelik', value: 'priority', sortable: false },
      { text: 'Detay', value: 'actions', sortable: false },
      { text: 'Kupon Durum', value: 'endDate', sortable: false },
      { text: 'Paket Adı', value: 'subscriptionType', sortable: false },
    ],

    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 2000 || 'Maksimum 2000 karakter olmalıdır.',
    ],
    shortDescriptionRules: [
      (v) => !!v || 'Kısa açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Resim gereklidir.',
      (v) => (v && v.name != null) || 'Resim gereklidir.',
    ],
    orderRules: [(v) => parseFloat(v) > -1 || "Adet 0'dan küçük olmamalıdır."],
    discountRules: [
      (v) =>
        parseFloat(v) >= 1 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
      (v) =>
        parseFloat(v) <= 25000 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
    ],
    codeRules: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) => v.length >= 6 || 'Genel kod 6-8 karakter olmalıdır.',
      (v) => v.length <= 8 || 'Genel kod 6-8 karakter olmalıdır.',
    ],
    noRule: [],
    campaignTypeRules: [(v) => !!v || 'Kampanya tipi alanı zorunludur.'],
    usageCountLimitOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    campaignList: [],
    campaignHeaders: [
      { text: 'Kampanya Id', value: 'id' },
      { text: 'Kampanya Başlık', value: 'title' },
      { text: '', value: 'campaignGroupId', sortable: false },
    ],
    selectAll: false,
    selectedCampaigns: [],
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    menu: false,

    campaignTypeList: [
      {
        name: 'Genel Kampanya',
        value: 'General',
      },
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Birliği',
        value: 'Partnership',
      },
    ],
    codeTypeList: [
      {
        name: 'Genel Kod',
        value: 'General',
      },
      {
        name: 'Unique Kod',
        value: 'Unique',
      },
      {
        name: 'No Code',
        value: 'NoCode',
      },
    ],
    errorList: [],
    dialog: false,
  }),
  computed: {
    ...mapGetters([
      'groupCampaignData',
      'allCampaigns',
      'loading',
      'allSegments',
      'campaignSelectList',
      'allSubscriptionTypes',
      'allSegmentTypes',
      'subscriptionLabels',
    ]),
  },
  created() {
    const id = this.$route.params.id
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.getGroupCampaign(id).then((x) => {
      this.campaignGroupTitle = x.title
    })
    this.campaignPageData.campaignGroupId = id
    this.campaignPageData.pageNumber = Number(page)
    this.getCampaigns(this.campaignPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.getCampaignSelectList(this.campaignSelectListData).then((response) => {
      this.selectedCampaigns = response
        .filter((x) => x.campaignGroupId == Number(id))
        .map((x) => x.id)
      console.log('selectedCampaigns', this.selectedCampaigns)
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.getSegments().then(() => {
      this.allSegments.unshift({ name: 'Hepsi', type: '' })
      console.log('segments fetched successfully')
    })
    this.getSubscriptionTypes().then()
  },
  methods: {
    ...mapActions([
      'getGroupCampaign',
      'getCampaigns',
      'updateCampaignStatus',
      'updateCampaignVisibility',
      'getSegments',
      'getCampaignSelectList',
      'updateSubCampaigns',
      'updateCampaignGroup',
      'getSubscriptionTypes',
    ]),
    saveCampaignGroupTitle() {
      const campaignGroup = {
        title: this.campaignGroupTitle,
        id: this.$route.params.id,
      }
      this.updateCampaignGroup(campaignGroup)
        .then((response) => {
          if (response.processStatus === 'Success') {
            alert('Grup kampanyası başarılı bir şekilde güncellendi.')
            this.getPageNumber(1)
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    //SubCampaignAdd
    routeSubCampaignAdd() {
      const id = this.$route.params.id

      this.$router.push(`/dashboard/groupCampaign/${id}/subCampaign`)
    },
    openPopup() {
      this.popupOpen = true
    },
    closePopup() {
      this.popupOpen = false
    },
    openCampaignPopup() {
      this.showPopup = true
    },
    closeCampaignPopup() {
      this.showPopup = false
    },

    toggleSelection(campaignId) {
      if (this.selectedCampaigns.includes(campaignId)) {
        this.selectedCampaigns = this.selectedCampaigns.filter(
          (id) => id !== campaignId,
        )
      } else {
        this.selectedCampaigns.push(campaignId)
      }
      console.log(this.selectedCampaigns)
    },
    addSubCampaigns() {
      const id = this.$route.params.id

      let updateSubCampaignsRequest = {
        id: id,
        subCampaignList: this.selectedCampaigns,
      }

      this.updateSubCampaigns(updateSubCampaignsRequest)
        .then((response) => {
          if (response.processStatus === 'Success') {
            alert('Grup kampanyası başarılı bir şekilde güncellendi.')
            this.getPageNumber(1)
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
      console.log(JSON.stringify(this.selectedCampaigns))
      this.closePopup()
      this.closeCampaignPopup()
    },
    tooltipMessage(item) {
      const endDate = new Date(item.endDate)
      const today = new Date()
      const oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (endDate < today) {
        return {
          message: 'Bu kampanya süresi sona erdi',
          icon: 'mdi-exclamation',
          color: 'crimson',
        }
      } else if (endDate <= oneWeekFromNow) {
        return {
          message: 'Bu kampanya yakında sonlanacaktır',
          icon: 'mdi-timelapse',
          color: '#FFCD3F',
        }
      }
      return { message: '', icon: '' }
    },
    //Data table item per page changed function
    getItemPerPage(val) {
      this.campaignPageData.pageSize = val
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
      })
    },

    //Data table page number changed function
    getPageNumber(val) {
      this.campaignPageData.pageNumber = val
      this.getCampaigns(this.campaignPageData)
    },

    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    getSelectedListPageNumber(val) {
      this.campaignSelectListData.pageNumber = val
    },
    getItemPerPageForSelectedList(val) {
      this.campaignSelectListData.pageSize = val
      this.campaignSelectListData.pageNumber = 1
    },
    filterByCampaignChanged(value) {
      this.campaignPageData.filterByCampaign = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterByCampaignStatus(value) {
      this.campaignPageData.filterByStatus = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterBySegmentStatus(value) {
      this.campaignPageData.filterBySegment = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //CampaignAdd
    routeCampaignAdd() {
      this.$router.push('campaign')
    },

    //CampaignStatus
    campaignStatusChange(campaign) {
      this.updateCampaignStatus(campaign)
        .then((response) => {
          if (response.processStatus == 'Success') {
            alert('Grup kampanyası başarılı bir şekilde güncellendi.')
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    campaignVisibilityChange(campaign) {
      this.updateCampaignVisibility(campaign)
        .then((response) => {
          if (response.processStatus == 'Success') {
            alert('Grup kampanyası başarılı bir şekilde güncellendi.')
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    getItemPerSearch(val) {
      this.campaignPageData.pageNumber = 1
      this.campaignPageData.search = val
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    getItemPerSearchForSelectedList(val) {
      this.campaignSelectListData.pageNumber = 1
      this.campaignSelectListData.search = val
      this.getCampaignSelectList(this.campaignSelectListData).then(
        (response) => {
          this.pagination.totalItems = response.totalCount
          this.pagination.pagesLength = response.totalPages
        },
      )
    },
    //CampaignEdit
    routeCampaignEdit(item) {
      // console.log(`campaign/${item.id}`);
      this.$router.push({ path: `/dashboard/campaign/${item.id}` })
    },
    redirectLink(endpoint) {
      window.open(
        endpoint,
        '_blank', // <- This is what makes it open in a new window.
      )
    },

    filterByDateChange(startDate, endDate) {
      startDate = startDate.split(/[- :]/)
      this.campaignPageData.startDate =
        startDate[2] + '-' + startDate[1] + '-' + startDate[0]

      endDate = endDate.split(/[- :]/)
      this.campaignPageData.endDate =
        endDate[2] + '-' + endDate[1] + '-' + endDate[0]

      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterBySubscriptionType(value) {
      this.campaignPageData.filterBySubscriptionType = value
      this.campaignPageData.pageNumber = 1
      this.getCampaigns(this.campaignPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
  },
  watch: {
    date: function () {
      this.nowDate = this.date
      this.datePickerDisable = false
    },
    'campaignPageData.search'(val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
    'campaignSelectListData.search'(val, oldVal) {
      console.log('asdasdas')
      if (val.length < 2 && oldVal.length < 1) return
      this.getItemPerSearchForSelectedList(val)
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  display: flex;
}

.tooltip-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}

.tooltip-icon:hover {
  color: darkred;

  .con {
    border-radius: 20px;
  }
}
</style>
